import { render, staticRenderFns } from "./IconSettings.vue?vue&type=template&id=1a8baca0&scoped=true&"
import script from "./IconSettings.vue?vue&type=script&lang=ts&"
export * from "./IconSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8baca0",
  null
  
)

export default component.exports